/** 本文に許可するinputを、状態表示専用のチェックボックスだけに制限する。 */
export function sanitizeTaskCheckbox(element: Element): boolean {
  if (element.getAttribute('type')?.toLowerCase() !== 'checkbox') return false;
  const checked = element.hasAttribute('checked');
  // フォームとの関連付け、イベント、任意の名前・値などは引き継がない。
  for (const name of element.getAttributeNames()) element.removeAttribute(name);
  element.setAttribute('type', 'checkbox');
  element.setAttribute('disabled', '');
  if (checked) element.setAttribute('checked', '');
  return true;
}
